import axios from 'axios'
import { toast } from 'react-toastify'

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

// ── Auth header ────────────────────────────────────────────────────────────────
api.interceptors.request.use((config) => {
  const dynamicUrl = localStorage.getItem('dynamicApiUrl');
  if (dynamicUrl) {
    config.baseURL = dynamicUrl;
  }

  const token = localStorage.getItem('authToken')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  config.headers['X-App-Version'] = 'v1.0.4'
  config.headers['ngrok-skip-browser-warning'] = '1' // Omitir pantalla de Ngrok

  return config
})

// ── Offline guard (opcional, axios ya maneja errores de red) ─────────────────────
// Quitamos la restricción estricta de navigator.onLine porque puede ser inconsistente
// en algunos dispositivos móviles y PWAs.

// ── Response / auth error handler ──────────────────────────────────────────────
api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response && [401, 403].includes(error.response.status)) {
      // Siempre limpiamos el token si el servidor dice que es inválido
      localStorage.removeItem('authToken');
      localStorage.removeItem('authUser');
      
      // Solo redireccionamos si no estamos ya en login, logout o en la página base
      const publicPaths = ['/', '/login', '/logout'];
      if (!publicPaths.includes(window.location.pathname)) {
        toast.error('Tu sesión ha vencido. Por favor, vuelve a ingresar.');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  },
);
